import React from "react";
import { Typography, Stack, Box, Container} from "@mui/material";

const HomePage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Stack spacing={2}>
        <Typography variant="h4" gutterBottom>
          Welcome to EchoBud
        </Typography>
        <Typography variant="body1" gutterBottom>
          EchoBud is your AI-powered companion for seamless interaction via WhatsApp.
          Learn more about how we handle your data by visiting our Privacy Policy.
        </Typography>
        <Box sx={{
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          overflow: "hidden",
          maxWidth: "100%",
          background: "#000",
          mb: 2,
        }}>
          <iframe
            src="https://www.youtube.com/embed/zVQgGuImDm8"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
          ></iframe>
        </Box>
      </Stack>
    </Container>
  );
};

export default HomePage;
